import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from '../locales/fr.json';
import en from '../locales/en.json';
import ar from '../locales/ar.json';

// Set French as default if no language is saved
const savedLanguage = localStorage.getItem('i18nextLng');
if (!savedLanguage) {
  localStorage.setItem('i18nextLng', 'fr');
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ar: { translation: ar }
    },
    lng: 'fr', // Default language
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'ar'],
    detection: {
      order: ['localStorage', 'querystring', 'cookie'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie']
    },
    interpolation: {
      escapeValue: false,
      prefix: '{{',
      suffix: '}}'
    }
  });

export default i18n;
